import {ReactNode} from "react";

import "./DrawerModalFooter.css";
import {FormOverlayButtons} from "./FormOverlayButtons.tsx";

interface DrawerModalFooterProps {
  onCancel?: () => void;
  submitText?: string;
  cancelText?: string;
  disabled?: boolean;
  formId?: string;
  hasSubmitButton?: boolean;
  hasCancelButton?: boolean;
  onSubmit?: () => void;
  isSecondaryLevel?: boolean;
  extraButtons?: ReactNode;
}

export const DrawerModalFooter = ({
  submitText,
  onCancel,
  cancelText,
  disabled,
  formId,
  hasSubmitButton,
  hasCancelButton,
  onSubmit,
  isSecondaryLevel,
  extraButtons,
}: DrawerModalFooterProps) => (
  <div className="DrawerModalFooter">
    <FormOverlayButtons
      disabled={disabled}
      form={formId}
      submitText={submitText}
      onClick={onCancel}
      cancelText={cancelText}
      hasCancelButton={hasCancelButton}
      hasSubmitButton={hasSubmitButton}
      onSubmit={onSubmit}
      isSecondaryLevel={isSecondaryLevel}
    />
    {extraButtons && extraButtons}
  </div>
);
